
































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { RateSourceModule } from '@/store/Products/RateSourceModule';
import RateCreate from '@/components/Products/Rates/RateCreate.vue';
import RateEdit from '@/components/Products/Rates/RateEdit.vue';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'RateSourceRates', components: { RateCreate, RateEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.rateSources.fields.rate'), width: "10%" },
        { text: this.$t('pageText.rateSources.fields.validFromDate'), width: "15%" },
        { text: this.$t('pageText.rateSources.fields.createdBy'), width: "15%" },
        { text: this.$t('pageText.rateSources.fields.createdAt'), width: "20%" },
        { text: this.$t('pageText.rateSources.fields.updatedBy'), width: "15%" },
        { text: this.$t('pageText.rateSources.fields.updatedAt'), width: "15%" },
        { text: this.$t('pageText.rateSources.fields.actions'), width: "10%" }
    ];
    ratesPage = 1;

    async beforeMount() {
        await RateSourceModule.getRatesForRateSource();
    }

    get loading() {
        return RateSourceModule.loadingRates;
    }

    get totalRatesPages() {
        return RateSourceModule.totalRatesPages;
    }

    get rates() {
        return RateSourceModule.rates;
    }

    get pageSize() {
        return RateSourceModule.pageSize;
    }

}
